export function hasSelection() {
    const sel = window.getSelection();
    if (sel && sel.rangeCount) {
        const range = sel.getRangeAt(0);
        if (!range.collapsed) {
            return true;
        }
    }

    return false;
}

export function getSelectionRange() {
    const sel = window.getSelection();
    if (sel && sel.rangeCount) {
        const range = sel.getRangeAt(0);
        if (!range.collapsed) {
            return range;
        }
    }

    return null;
}

export function getCursorRange() {
    const sel = window.getSelection();
    if (sel && sel.rangeCount) {
        return sel.getRangeAt(0);
    }

    return null;
}

export function setSelectionRange(range: Range) {
    const s1 = window.getSelection();
    if (s1) {
        s1.removeAllRanges();
    }

    const s2 = window.getSelection();
    if (s2) {
        s2.addRange(range);
    }
}

export function clearSelection() {
    const sel = window.getSelection();

    if (sel && sel.rangeCount) {
        const range = sel.getRangeAt(0);
        range.collapse(true);
    }
}

export function getSelectedText() {
    const s = window.getSelection();
    return s ? s.toString() : "";
}

export function setPositionInContentEditable(
    elm: HTMLElement,
    position: number
) {
    try {
        const range = document.createRange();
        const sel = window.getSelection();
        if (sel) {
            sel.removeAllRanges();
            range.setStart(elm.childNodes[0], position);
            range.collapse(true);
            sel.addRange(range);
        }
    } catch (e) {
        console.warn("setPositionInContentEditable");
        console.warn(e);
    }
}
